import React, { useEffect, useState } from "react";
import InsHeader from "../components/InsHeader/InsHeader";
import InsCGUBar from "../components/InsCGUBar/InsCGUBar";
import InsNavigation from "../components/InsNavigation/InsNavigation";
import { withTranslation } from "react-i18next";
import * as microsoftTeams from "@microsoft/teams-js";
import { useLocation } from "react-router-dom";

const DefaultLayout = ({ children }) => {
  const [showFooter, setshowFooter] = useState(true);
  const location = useLocation();

  useEffect(() => {
    microsoftTeams.initialize(() => {
      setshowFooter(false);
    });
  }, []);

  return (
    <>
      <InsHeader />
      <div className="default-layout--container">{children}</div>
      <InsCGUBar location={location} />
      {showFooter && <InsNavigation />}
    </>
  );
};

export default DefaultLayout;
